import { render, staticRenderFns } from "./ShareSubView.vue?vue&type=template&id=7c4b760b&"
import script from "./ShareSubView.vue?vue&type=script&lang=ts&"
export * from "./ShareSubView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports